import { APIResponse } from "../types/api.types";
import { APIQuery } from "./api.base";

export const list = async (): Promise<APIResponse> => APIQuery("/session/list", "GET", []);
export const revoke = async (sessionId: string): Promise<APIResponse> => APIQuery("/session/revoke", "POST", [], { session_id: sessionId });
